common.View.create('canvas.blocks.custom.discover.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: false,
                margin: 15,
                nav: true, // this.element.find('.owl-carousel').data('show-navigation')
                navText : [
                    "<span class='sr-only'>Previous</span><i class='far fa-arrow-left'></i>",
                    "<span class='sr-only'>Next</span><i class='far fa-arrow-right'></i>"
                ],
                // navText: [this.element.find('.owl-prev'), this.element.find('.owl-next')],
                navContainer: this.element.find('.owl-nav'),
                navElement: 'button type="button" role="presentation" title="Slider navigation"',
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                stagePadding: 60,
                responsive: {
                    0: {
                        items: 1
                    },
                    640: {
                        items: 2,
                    },
                    1000: {
                        items: 5,
                    }
                }
            });

    }
});
